import { CountryCode } from '../linkedin-accounts.types';
import { OptionType } from 'features/ui/base-components/pai-auto-complete';

/**
 * Find country and city options for a given account
 */
export function findCountryAndCity(
  allCountryCodes: CountryCode[],
  countryCode: string | undefined,
  cityCode: string | undefined
): { country: OptionType; city: OptionType } {
  let country: OptionType = { label: '', value: '' };
  let city: OptionType = { label: '', value: '' };

  if (!countryCode) {
    return { country, city };
  }

  const foundCountry = allCountryCodes.find((c) => c.code === countryCode);

  if (foundCountry) {
    country = { label: foundCountry.name, value: foundCountry.code };

    if (cityCode) {
      const foundCity = foundCountry.cities.options.find((c) => c.code === cityCode);
      if (foundCity) {
        city = { label: foundCity.name, value: foundCity.code };
      }
    }
  }

  return { country, city };
}

/**
 * Get city options for a selected country
 */
export function getCitiesForCountry(
  allCountryCodes: CountryCode[],
  countryCode: string
): OptionType[] {
  const foundCountry = allCountryCodes.find((c) => c.code === countryCode);

  if (!foundCountry) {
    return [];
  }

  return foundCountry.cities.options.map((city) => ({
    label: city.name,
    value: city.code,
  }));
}

/**
 * Convert country codes to option type array
 */
export function countryCodeToOptions(allCountryCodes: CountryCode[]): OptionType[] {
  return allCountryCodes.map((country) => ({
    label: country.name,
    value: country.code,
  }));
}

